<template>
    <IconElement
        :icon="icon"
    />
</template>
<script>

const IconElement = {
    name: 'IconElement',
    props: {
        icon: { type: String }
    },
    render: function(createElement) {
        return createElement('svg', {
            class: {
                'BaseIcon' : true,
            }
        }, [
            createElement('use', {
                attrs: {
                    'href' : '/dist/icons.svg#' + this.icon
                }
            })
        ])
    }
}

export default {
    name: 'BaseIcon',
    components: {
        IconElement
    },
    props: {
        icon: { type: String, required: true },
    }
}
</script>
<style lang="scss">
    .BaseIcon  {
        display: inline-block;
        width: 1em;
        height: 1em;
        stroke-width: 0;
        stroke: currentColor;
        fill: currentColor;

        .is-icon-left & {
            transform: rotate(180deg);
        }
    }

</style>
